"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillCodeResponseMapper = void 0;
var BillCodeResponseMapper = /** @class */ (function () {
    function BillCodeResponseMapper(data) {
        this.localData = data;
    }
    BillCodeResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return BillCodeResponseMapper;
}());
exports.BillCodeResponseMapper = BillCodeResponseMapper;
//# sourceMappingURL=BillCodeResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/models/mappers/BillCodeResponseMapper.js
// module id = 1442
// module chunks = 8